import React, { useState, useEffect } from "react";
import { Input } from "antd";
const { TextArea } = Input;
const TxtEditEditor = ({ fileUuid, textContent }) => {
  const [markdownValue, setMarkdownValue] = useState(textContent);
  const handleChange = (e) => {
    setMarkdownValue(e.target.value);
  };
  useEffect(() => {
    setMarkdownValue(textContent);
  }, [textContent]);
  return (
    <div>
      <TextArea
        rows={4}
        value={markdownValue}
        showCount
        maxLength={10000}
        onChange={handleChange}
        style={{
          height: 400,
          resize: "none",
          marginBottom:"20px"
        }}
      />
    </div>
  );
};

export default TxtEditEditor;
